<template>
  <div class="extension-container">

    <sb-table
      class="extension-table left-right-align"
      :columns="columns"
      :rows="rows"
    >
      <template #cell="{ row, column }">
        <div
          v-if="column.key === 'dataValue' && row.type === 'image'"
          class="image-wrap"
        >
          <img v-if="!!row.dataValue" class="thumbnail" :src="row.dataValue" alt="extension-image" />
          <div v-else>none</div>
        </div>
        <div v-else>
          {{ row[column.key] }}
        </div>
      </template>
    </sb-table>
  </div>
</template>

<script>
import { differenceInDays } from 'date-fns'

export default {
  props: {
    extension: Object,
    isOffer: Boolean
  },

  name: 'Extension',

  data() {
    return {
      columns: [{ label: '', key: 'dataKey' }, { label: '', key: 'dataValue' }],
      extensionConfig: null,
      rows: [],
    }
  },

  created() {
    this.setRewardData()
  },

  computed: {
    bonusPoints: function() {
      const bonusType = this.extensionConfig.bonusType === 'add' ? '+' : 'x'
      return this.extensionConfig.bonusType ? `${bonusType} ${this.extensionConfig.bonusValue}` : 'loading'
    },

    couponImage() {
      const image = this.extensionValue.attachments.filter(
        (attachment) => attachment.label === 'coupon'
      )
      return image[0]?.thumb
    },

    extensionValue() {
      return this.extension?.value
    },

    preloadImage() {
      const image = this.extensionValue.attachments.filter(
        (attachment) => attachment.label === 'preload'
      )
      return image[0]?.thumb
    },

    rewardPoints() {
      const points = this.extensionConfig.bonusValue ? Number(this.extensionConfig.bonusValue) : 0
      return points.toLocaleString('en-US', { minimumFractionDigits: 2 })
    },
  },

  methods: {
    calculateDaysFromEpoch(dateString) {
      if (!dateString) return '--'

      const epochDate = new Date('01/01/1970')
      const expiryDate = new Date(dateString)
      const diff = differenceInDays(epochDate, expiryDate)
      return diff < 2 ? `${diff} day` : `${diff} days`
    },

    configureRows() {
      const selectedColumns = {}
      const isAnyLink = this.extension.name === 'any link'

      if (this.extension.name === 'wallet target') {
        selectedColumns[this.extension.name] = this.extensionValue
      }

      if (this.isOffer) {
        if (this.extension.needOffer) {
          selectedColumns['offer'] = this.extensionValue.item_name
        }
        selectedColumns['offer type'] = this.extensionConfig.offerType
        if (this.extensionConfig.isBonusReward) {
          selectedColumns['bonus points'] = this.bonusPoints
          selectedColumns['min purchase amount'] = this.extensionConfig.minPurchaseAmount
        }
        if (this.extensionConfig.isInstantPoints) {
          selectedColumns['instant points'] = this.rewardPoints
        } else {
          selectedColumns['# of uses'] = this.extensionConfig.maxRedemptions
          selectedColumns['offer expires after'] = this.extensionConfig.expirationDate
        }

        selectedColumns['preload image'] = this.preloadImage

        if (this.extensionValue && !this.extensionValue.type) {
          selectedColumns['voucher image'] = this.couponImage
        }
      }

      if (this.extension.name === 'any link') {
        this.rows = this.extensionValue.map((value, index) => ({
          dataKey: index === 0 ? 'any link' : '',
          dataValue: value.url,
        }))
      } else {
        this.rows = Object.keys(selectedColumns).map((key) => ({
          dataKey: key,
          dataValue: selectedColumns[key],
          type: ['preload image', 'voucher image'].includes(key) ? 'image' : '',
        }))
      }
    },

    setRewardData() {
      if (this.extensionValue) {
        if (this.isOffer) {
          const minPurchase = this.extensionValue.min_purchase_amount

          this.extensionConfig = {
            bonusType: this.extensionValue.bonus_type,
            bonusValue: this.extensionValue.bonus_value,
            expirationDate: this.calculateDaysFromEpoch(this.extensionValue.expiry_days),
            isDigitalVoucher: this.extension.name === 'digital voucher',
            isBonusReward: this.extensionValue.type === 'BonusReward',
            isInstantPoints: this.extensionValue.type === 'InstantReward',
            maxRedemptions:
              this.extensionValue.max_redemptions === -1
                ? 'unlimited'
                : this.extensionValue.max_redemptions,
            minPurchaseAmount:
              !!minPurchase && minPurchase > 0
                ? `$${minPurchase.toFixed(1)}`
                : minPurchase,
            offerType: this.extension.name
          }
        }
        this.configureRows()
      }
    },
  },
}
</script>

<style lang="sass">
.extension-container
  .extension-table
    .image-wrap
      line-height: 0
    .thumbnail
      height: 50px
</style>